import { Control, Path, useController } from 'react-hook-form';

import { FormValues } from '../types';

export interface UseClassList<T extends FormValues> {
  control: Control<T>;
  name: Path<T>;
}

const useClassList = <T extends FormValues>({ control, name }: UseClassList<T>) => {
  const { field } = useController({ control, name });
  const { value } = field;

  const selectedClassId: MongoId | null = value ? (value as MongoId) : null;

  return { selectedClassId };
};

export default useClassList;
